import { Action } from '@liveauctioneers/caterwaul-components/lib/hooks/queryParams';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getSavedSearchById, toggleSavedSearchEmail } from '@/redux/modules/savedSearch';
import { parseQueryParams } from '@/utils/queryParams';
import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { toFacetString } from '@/utils/savedSearchFacets';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useLocation } from 'react-router-dom';
import { useQueryParams } from '@/hooks/queryParams';
import React from 'react';

export const useUnsubscribeFollowedSearch = (fetchSavedSearches: () => void) => {
    const intl = useIntl();
    const appDispatch = useAppDispatch();
    const { pathname, search } = useLocation();
    const queryParams = parseQueryParams<{ unsubscribeAlert?: string }>(search);
    const savedSearchId = Number(queryParams?.unsubscribeAlert);
    const { modifyQueryParams } = useQueryParams();
    const email = useAppSelector(getBidderEmail);
    const [toastSent, setToastSent] = React.useState(false);
    const savedSearch = useAppSelector((state) => getSavedSearchById(state, savedSearchId));

    const autoUnsubscribe = React.useCallback(() => {
        const keyword = toFacetString(savedSearch?.facets || [], intl);
        if (savedSearch?.sendAlert) {
            appDispatch(toggleSavedSearchEmail(savedSearch.savedSearchId));
            toast('success', {
                description: intl.formatMessage({ id: 'unsubscribeEmail' }, { alert: keyword, email }),
                title: intl.formatMessage({
                    id: 'toastMessages.titles.success',
                }),
            });
        } else {
            toast('success', {
                description: intl.formatMessage({ id: 'unsubscribeEmailAlready' }, { alert: keyword, email }),
                title: intl.formatMessage({
                    id: 'toastMessages.titles.success',
                }),
            });
        }
        setToastSent(true);
        fetchSavedSearches();
        modifyQueryParams({
            action: Action.REMOVE,
            params: 'unsubscribeAlert',
            pathname,
        });
        return;
    }, [
        savedSearch?.facets,
        savedSearch?.sendAlert,
        savedSearch?.savedSearchId,
        intl,
        fetchSavedSearches,
        modifyQueryParams,
        pathname,
        appDispatch,
        email,
    ]);

    React.useEffect(() => {
        if (!toastSent && savedSearchId) {
            autoUnsubscribe();
        }
    }, [autoUnsubscribe, savedSearch?.sendAlert, savedSearchId, toastSent]);

    return null;
};
